import React, { useRef, useEffect } from "react";
const searchIcon = require("../images/search-icon.svg");
const whiteRightArrowIcon = require("../images/white-right-arrow.svg");

const Keywords = ({
  keywords,
  updateKeywords
}: {
  keywords: string;
  updateKeywords: (keywords: string) => void;
}) => {
  const inputRef: any = React.createRef();

  useEffect(() => {
    const setupKeywordsAutosuggest = () => {
      // @ts-ignore
      $("#search-photos").soulmate({
        url: "/search/search",
        types: ["events"],
        renderCallback: (term: string, data: any, type: "events") => {
          return term + " - " + data.date;
        },
        selectCallback: (term: string, data: any, type: "events") => {
          window.location.href = data.link;
        },
        filterCallback: (result: any, type: "events") => {
          return new Date(result.data.date) <= new Date();
        },
        minQueryLength: 1,
        maxResults: "",
        timeout: 2000
      });
    };

    setupKeywordsAutosuggest();
  }, []);

  return (
    <div className="tab-pane fade active in" id="tab-keywords">
      <label htmlFor="search-photos" className="search-bar flex-row">
        <span className="search-label">
          <img src={searchIcon} alt="" />
        </span>
        <input
          id="search-photos"
          type="text"
          className="search-field"
          placeholder="Type to search events"
          ref={inputRef}
          defaultValue={keywords}
          onKeyDown={e => {
            if (e.key === "Enter") {
              // @ts-ignore
              $("ul#soulmate").hide();
              updateKeywords(inputRef.current.value);
            }
          }}
        />
        <button
          type="submit"
          className="btn secondary-btn key-btn"
          onClick={() => updateKeywords(inputRef.current.value)}
        >
          <img src={whiteRightArrowIcon} alt="" />
        </button>
      </label>
    </div>
  );
};

export default Keywords;
